<div class="text-center" id="presentation">
    <div class="about-container">
        <h2>Nos marques de véhicules</h2>
        <div class="ui container margin-top-50">
            <div class="ui two column stackable grid">
                <new-car-brand *ngFor="let brand of brands" [brand]="brand" class="column margin-bottom-50"></new-car-brand>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/new-car/presentation/presentation.html